/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { LeadFieldKind } from './leadFieldKind'

/**
 * リード（PII）項目型。非nullなら入力値はリード表へ隔離保存（questionType 無視・ADR-0012） @example "EMAIL"
 * @nullable
 */
export type SurveyQuestionLeadFieldKind = LeadFieldKind | null
